<template>
  <div
    id="history"
    class="history"
    data-test="history"
  >
    <div class="card">
      <header class="card-header">
        <div class="card-header-title">
          <h4 class="is-size-1">
            {{ $t('seo_service.report_history.title') }}
          </h4>
        </div>
      </header>
      <div class="card-content">
        <div class="content">
          <div class="table__wrapper">
            <table class="table">
              <thead>
                <tr>
                  <th
                    v-for="field in fields"
                    :key="field"
                  >
                    {{ field }}
                  </th>
                </tr>
                <tr
                  v-for="report in sortedReports"
                  :key="report.Date"
                >
                  <td>{{ report.Date }}</td>
                  <td>
                    <a
                      href="#"
                      data-test="getReportByDate"
                      @mouseover="getReportByDate(report.Date)"
                      @click.prevent="showReportByDate(report.Date)"
                    >
                      {{ $t('seo_service.report_history.view_report') }}
                    </a>
                  </td>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GET_LAST_REPORT from '../../graphql/GET_LAST_REPORT.gql'
export default {

  name: 'ReportHistoryList',
  props: {
    serviceId: {
      type: String,
      default: ''
    },
    reports: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fields: [
        this.$t('seo_service.report_history.table_headers.date'),
        this.$t('seo_service.report_history.table_headers.action')
      ]
    }
  },
  computed: {
    sortedReports () {
      return this.reports
        .filter(report => report.IsComplete === true)
        .sort((report1, report2) => report1.Date < report2.Date)
    }
  },
  methods: {
    getReportByDate (date) {
      this.$apollo.query({
        query: GET_LAST_REPORT,
        variables: {
          seoId: this.$route.params.serviceId,
          date: date
        }
      })
    },
    showReportByDate (date) {
      this.$emit('showReportByDate', date)
    }
  }
}
</script>

<style lang="scss" scoped>
.table__wrapper {
  overflow-x: auto;
  margin: -1.6rem;
}
.history {
  margin-bottom: 10px;
}
.card-header {
  background-color: #eeeeee;
}
</style>
